module.exports = __webpack_public_path__ + "static/img/22.8450bc80.png";